import {throttle} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';
import {getScroller, getScrollTop} from '../../common/utils/dom';
export default {
    name: getComponentName('ScrollDetector'),
    data: function data() {
        return {
            scrollTop: '',
            el: null,
            container: null,
            visible: false,
            backScrollStatus: false
        };
    },
    props: {
        target: {
            type: Function,
            default: function _default() {
                return getScroller(this.$el);
            }
        },
        visibilityHeight: {
            type: Number,
            default: 0
        },
        referQuery: {
            type: Function,
            default: function _default() {
                return getScroller(this.$el);
            }
        },
        referNum: {
            type: Number,
            default: 2
        },
        backScroll: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        scrollMinHeight: function scrollMinHeight() {
            var visibilityHeight = this.visibilityHeight;
            var referQuery = this.referQuery();
            var referNum = this.referNum;

            if (visibilityHeight !== 0) {
                return visibilityHeight;
            } else {
                if (referQuery === window) {
                    return window.innerHeight * referNum;
                } else if (referQuery instanceof HTMLElement) {
                    return referQuery.offsetHeight * referNum;
                }

                if (!this.el) {
                    throw new Error('target is not existed: '.concat(this.target));
                }
            }
        }
    },
    mounted: function mounted() {
        this.init();
        this.throttledScrollHandler = throttle(this.handleScroll, 300, true);
        this.handlerEvents();
    },
    destroyed: function destroyed() {
        this.removeEvents();
    },
    methods: {
        init: function init() {
            if (typeof this.target === 'function') {
                this.el = this.target();

                if (!this.el) {
                    throw new Error('target is not existed: '.concat(this.target));
                }

                this.container = this.el;
            } else {
                this.el = getScroller(this.$el);
                this.container = this.el;
            }
        },
        handlerEvents: function handlerEvents() {
            this.container.addEventListener('scroll', this.throttledScrollHandler);
        },
        removeEvents: function removeEvents() {
            this.container.removeEventListener('scroll', this.throttledScrollHandler);
        },
        handleScroll: function handleScroll() {
            var scrollTop = getScrollTop(this.el);
            var scrollMinHeight = this.scrollMinHeight;

            if (this.backScroll) {
                if (!this.backScrollStatus && scrollTop - this.scrollTop < 0) {
                    this.backScrollStatus = true;
                }

                if (this.backScrollStatus && scrollTop - this.scrollTop > 0) {
                    this.backScrollStatus = false;
                }
            } else {
                this.backScrollStatus = true;
            }

            this.scrollTop = scrollTop;
            this.visible = scrollTop > scrollMinHeight && this.backScrollStatus;
        }
    },
    render: function render() {
        var h = arguments[0];

        var _a;

        return h('div', [
            ((_a = this.$scopedSlots) === null || _a === void 0
              ? void 0
              : _a.default)
                ? this.$scopedSlots.default({
                      visible: this.visible
                  })
                : ''
        ]);
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
